module.exports = __webpack_public_path__ + "assets/img/icon1-menu.26aa6029.svg";